<div class="emg card" *ngIf="summary" [class.emg--stale]="!isCurrent">
  <!--
    Document state comes FIRST — before the name, before the code status.
    A card printed from an older version outlives that version, and a stale
    DNR read as live is the worst outcome this screen can produce.
  -->
  <div class="emg__state" *ngIf="!isCurrent" role="alert">
    <span class="emg__state-label">{{ stateLabel }}</span>
    <span class="emg__state-hint">{{ stateHint }}</span>
  </div>

  <p class="page__eyebrow">Emergency summary</p>
  <h1 class="emg__name">{{ summary.patientName }}</h1>

  <!-- CODE STATUS — front and center, unmistakable -->
  <div
    class="emg__code"
    [class.emg__code--ok]="cpr === 'yes'"
    [class.emg__code--danger]="cpr === 'no'"
    [class.emg__code--warn]="cpr === 'unsure'"
    [class.emg__code--muted]="cpr === null"
  >
    <span class="emg__code-label">Code status — CPR</span>
    <span class="emg__code-value">{{ cprLabel }}</span>
    <span class="emg__code-source" *ngIf="sourceLabel">
      Source: {{ sourceLabel }}
    </span>
  </div>

  <!-- Blockchain verdict -->
  <div class="emg__chain">
    <span class="pill pill--ok" *ngIf="summary.blockchain?.verified">
      ⛓ Verified unchanged<ng-container *ngIf="shortTxId">&nbsp;· <span class="emg__tx">{{ shortTxId }}</span></ng-container>
    </span>
    <span class="pill pill--warn" *ngIf="!summary.blockchain?.verified">
      ⚠ Could not confirm this record is unchanged
    </span>
  </div>

  <p class="emg__integrity emg__integrity--fail" *ngIf="summary.integrityResult === 'fail'">
    ⚠ This record does NOT match what was signed. Treat with caution and confirm with the care team.
  </p>
  <p class="emg__integrity emg__integrity--unknown" *ngIf="summary.integrityResult === 'unknown'">
    Integrity could not be verified right now. Access has been recorded.
  </p>

  <!--
    Clinical facts that change treatment in the first five minutes. Rendered
    ABOVE the agent's contact details, because an allergy or a blood thinner
    changes what you do right now, whereas the agent is who you call next.
    The whole block is hidden when nothing is recorded — an empty "Allergies"
    heading reads as "none known", which is a claim we cannot make.
  -->
  <div class="emg__clinical" *ngIf="summary.emergencyInfo as info">
    <div class="emg__clinical-row emg__clinical-row--alert" *ngIf="info.allergies?.length">
      <span class="emg__clinical-label">Allergies</span>
      <ul class="emg__clinical-list">
        <li *ngFor="let allergy of info.allergies">{{ allergy }}</li>
      </ul>
    </div>

    <div class="emg__clinical-row emg__clinical-row--alert" *ngIf="info.bloodThinners?.length">
      <span class="emg__clinical-label">Blood thinners</span>
      <ul class="emg__clinical-list">
        <li *ngFor="let thinner of info.bloodThinners">{{ thinner }}</li>
      </ul>
    </div>

    <div class="emg__clinical-row emg__clinical-row--alert" *ngIf="info.implantedDevices?.length">
      <span class="emg__clinical-label">Implanted devices</span>
      <ul class="emg__clinical-list">
        <li *ngFor="let device of info.implantedDevices">{{ device }}</li>
      </ul>
    </div>

    <div class="emg__clinical-row" *ngIf="info.conditions?.length">
      <span class="emg__clinical-label">Conditions</span>
      <ul class="emg__clinical-list">
        <li *ngFor="let condition of info.conditions">{{ condition }}</li>
      </ul>
    </div>

    <div class="emg__clinical-row" *ngIf="info.bloodType">
      <span class="emg__clinical-label">Blood type</span>
      <span class="emg__clinical-value">{{ info.bloodType }}</span>
    </div>

    <div class="emg__clinical-row" *ngIf="info.preferredLanguage || info.interpreterNeeded">
      <span class="emg__clinical-label">Language</span>
      <span class="emg__clinical-value">
        {{ info.preferredLanguage || 'Not English' }}
        <strong *ngIf="info.interpreterNeeded"> — interpreter needed</strong>
      </span>
    </div>
  </div>

  <!-- Health care agent -->
  <div class="emg__agent" *ngIf="summary.agent?.name">
    <span class="emg__agent-label">Health care agent</span>
    <span class="emg__agent-name">{{ summary.agent?.name }}</span>
    <a class="emg__agent-phone" *ngIf="summary.agent?.phone" href="tel:{{ summary.agent?.phone }}">
      <i class="pi pi-phone" aria-hidden="true"></i> {{ summary.agent?.phone }}
    </a>
  </div>

  <footer class="emg__footer">
    This is the emergency summary. Full document requires a registered device.
    <span class="emg__footer-hint">— Registered this device before? Codes/tokens may have been cleared.</span>
  </footer>
</div>
